enum ResponsiveLayout {
    mobile = 'mobile',
    tablet = 'tablet',
    desktop = 'desktop',
    huge = 'huge'
}

export default ResponsiveLayout
